<template>
  <div>
    <Card title="Patient" :loading="loading">
      <PatientBasic
        ref="patientBasic"
        :new-patient="newPatient"
        :existing-patient-details.sync="generalDetails"
        :allowUserToEditOrNot="allowUserToEditOrNot"
        :schema="_.find(schema, { title: 'Patient' }).fields"
      />
    </Card>
    <Card title="Patient Information" :loading="loading">
      <PatientInformation
        v-if="schema.length > 0"
        ref="patientInformation"
        :existing-dose-details.sync="doseDetails"
        :existing-patient-details.sync="generalDetails"
        :patient-model="patientModel"
        :allowUserToEditOrNot="allowUserToEditOrNot"
        @validated="onValidated"
        @change="onChange($event, field)"
        @commonFunction="commonFunction"
        :schema="_.find(schema, { title: 'Patient information' }).fields"
      />
    </Card>
    <Card title="Events" :loading="loading">
      <EventTable
        :general-details="generalDetails"
        :existing-events.sync="events"
        :patient-model="patientModel"
        :allowUserToEditOrNot="allowUserToEditOrNot"
        :schema="_.find(schema, { title: 'Events' }).fields"
      />
    </Card>
  </div>
</template>

<script>
import Card from "@/new-components/ui/Card";
import PatientBasic from "@/new-components/patient/PatientBasic";
import PatientInformation from "@/new-components/patient/PatientInformation";
import EventTable from "@/new-components/patient/EventTable";
import { orderBy } from "lodash";
import _ from "lodash";

export default {
  name: "PatientInformationTab",

  components: {
    Card,
    PatientBasic,
    PatientInformation,
    EventTable,
  },

  props: {
    newPatient: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
    patientModel: { type: String, default: "" },
    generalDetails: { type: Object, required: true },
    doseDetails: { type: Object, required: true },
    events: { type: Array, required: true },
    allowUserToEditOrNot: { type: Boolean, required: false },
    patientDetails:  { type: Object, required: true },
    schema: { type: Array, required: true}
  },
  watch: {
    schema(value) {
      this.fields = orderBy(value, ["order"], ["asc"]);
      // this.updateField("gestationalAge", "hide", true);
    },
    
  },
  methods: {
    triggerValidate() {
      this.$refs.patientInformation.validate = false;
      this.$refs.patientBasic.validate = false;
      this.$nextTick(() => {
        this.$refs.patientInformation.validate = true;
        this.$refs.patientBasic.validate = true;
      });
    },
    onValidated() {
      const isValid =
        this.$refs.patientInformation.formValid &&
        this.$refs.patientBasic.formValid;
      this.$emit("valid", isValid);
    },
    commonFunction(v, key, type) {
      this.$emit("commonFunction", v, key, type);
    },
  },
  computed: {
    _() {
      return _;
    },
  },
};
</script>
